<template>
  <div class="finance">
    <div class="finance-content">
      <div class="finance-time"><van-icon name="bill" /> {{finance.created | datetime}}</div>
      <strong class="finance-fee">{{finance.fee}}元</strong>
    </div>
    <div class="finance-title">{{finance.title}}</div>
  </div>
</template>
<script>
import { Icon } from 'vant'
export default {
  name: 'SimpleFinance',
  components : {
    [ Icon.name ] : Icon
  },  
  props: {
    finance : Object
  }
}
</script>
<style lang="less" scoped>
  .finance {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  .finance-content {
    display: flex;
    justify-content: space-between;
  }
  .finance-fee {
    color: red;
  }
  .finance-title {
    color: gray;
  }
</style>